import { render } from "./index.vue?vue&type=template&id=361b0b3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=361b0b3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-361b0b3e"

export default script